import { APP_LOGO } from "./config";

export default function AuthLayout({ children }) {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh", backgroundColor: "#f8f9fc" }}
    >
      <div className="card shadow" style={{ width: "400px" }}>
        <div className="card-header bg-white border-bottom text-center">
          <div
            className="d-flex justify-content-center align-items-center rounded-circle bg-white shadow mx-auto mb-4"
            style={{ width: "100px", height: "100px" }}
          >
            <img src={APP_LOGO} height={80} alt="Logo" />
          </div>
        </div>
        <div className="card-body">{children}</div>
      </div>
    </div>
  );
}
